<template>
    <div id="banner" class="section">
        <img class="company-logo" src="../../../assets/images/logos/company-logo.png" alt="Comapny Logo">
        <h1 class="header">{{ $t("banner.header") }}</h1>
        <h2 class="motto">{{ $t("banner.motto") }}</h2>
        <div class="banner-buttons">
            <a href="mailto:info@m2pay.solutions">
                <input class="banner-button" type="button" :value="$t('banner.learn-more-button')">
            </a>
            <input class="banner-button" type="button" :value="$t('banner.contact-us-button')" @click="scrollToElement()">
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        scrollToElement() {
            const el = document.getElementById("footer");

            if (el) {
                el.scrollIntoView(
                    {
                        behavior: 'smooth'
                    }
                );
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #banner {
        background: linear-gradient(#00968814, rgba(0, 0, 0, 0.8)), url("../../../assets/images/backgrounds/banner.jpg");
        background-position: center;
        background-size: cover;
        height: 100vh;
        padding: 0px;

        .company-logo {
            position: absolute;
            top: 80px;
            left: 10%;
            width: 140px;
        }

        .header {
            width: 100%;
            text-align: center;
            font-size: 60px;
            color: #fff;

            @media screen and (max-width: 1000px) {
                &.header {
                    transform: scale(0.75);
                }
            }
        }

        .motto {
            width: 100%;
            text-align: center;
            font-size: 30px;
            font-weight: 500;
            color: #fff;

            @media screen and (max-width: 1000px) {
                &.motto {
                    transform: scale(0.75);
                }
            }
        }

        .banner-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 50px;
            width: 340px;

            .banner-button {
                border: 1px solid #fff;
                width: 150px;
                height: 50px;
                background: 0;
                color: #fff;
                font-size: 15px;
                transition: 1s;

                &:hover {
                    scale: 1.1;
                }
            }
        }
    }
</style>